import { render, staticRenderFns } from "./SignUp2.vue?vue&type=template&id=15c6c255&"
import script from "./SignUp2.vue?vue&type=script&lang=js&"
export * from "./SignUp2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports